import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import React from 'react';
import { FontAwesome, Entypo, Ionicons, MaterialCommunityIcons } from '@expo/vector-icons';
import { getIST } from '../utilities/Utility';

const OpportunityCard = ({ item, navigation }) => {

	return (
		<View>
			<TouchableOpacity
				style={{
					padding: 12,
					borderRadius: 8,
					shadowColor: 'gray',
					backgroundColor: 'white',
					shadowOffset: { width: 2, height: 4 },
					elevation: 5,
					shadowOpacity: 0.26,
					margin: 3,
				}}
				onPress={() => {
					// navigation.navigate('Device Activation', item);
				}}
			>
				<View
					style={{
						flexDirection: 'row',
						alignItems: 'center',
						justifyContent: 'space-between',
						flexWrap: 'wrap',
					}}
				>
					<Text style={{ fontSize: 18, fontWeight: '500' }}>{item.name}</Text>
					<Text
						style={{
							fontSize: 16,
							color: 'black',
							fontWeight: '600',
						}}
					>
						{item.subscriptionPlan + '(' + item.dayLeftForExpiry + ')'}
					</Text>
				</View>
				<View
					style={{
						flexDirection: 'row',
						alignItems: 'center',
						justifyContent: 'space-between',
						marginVertical: 8,
						flexWrap: 'wrap',
					}}
				>
					<View style={{ flexDirection: 'row', alignItems: 'center' }}>
						<MaterialCommunityIcons name="sim" size={22} color={'#fa3c0c'} />
						<Text
							style={{
								fontWeight: '600',
								color: 'gray',
								marginLeft: 4,
								fontSize: 14,
							}}
						>
							{item.sIMNUMBER}
						</Text>
					</View>
					<View
						style={{
							flexDirection: 'row',
							alignItems: 'center',
							flexWrap: 'wrap',
						}}
					>
						<Ionicons name="time-outline" size={22} color={'green'} />
						<Text style={{ fontWeight: '600', color: 'gray', marginLeft: 2 }}>
							{new Date(item.activiationDate).toLocaleDateString()}
						</Text>
					</View>
				</View>
				<View
					style={{
						flexDirection: 'row',
						alignItems: 'center',
						justifyContent: 'space-between',
						marginVertical: 8,
						flexWrap: 'wrap',
					}}
				>
					<View style={{ flexDirection: 'row', alignItems: 'center' }}>
						<FontAwesome name="barcode" size={22} color={'black'} />
						<Text
							style={{
								fontWeight: '600',
								color: 'gray',
								marginLeft: 6,
								fontSize: 14,
							}}
						>
							{item.iMEINUMBER}
						</Text>
					</View>
					<View style={{ flexDirection: 'row', alignItems: 'center' }}>
						<FontAwesome name="car" size={22} color={'#0c8bfa'} />
						<Text
							style={{
								fontWeight: '600',
								color: 'gray',
								marginLeft: 6,
								fontSize: 14,
							}}
						>
							{item.vehicleNumber}
						</Text>
					</View>
				</View>
			</TouchableOpacity>
		</View>
	);
};

export default OpportunityCard;

const styles = StyleSheet.create({});
